import React from 'react'
import Switch from '@material-ui/core/Switch'
import { withRouter, RouteComponentProps } from 'react-router'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import XLSX from 'sheetjs-style'
import * as FileSaver from 'file-saver'
import Page from 'components/Page'
import Filter from 'components/Page/Home/Filter'
import MapView from 'components/Page/Home/MapView'
import ListView from 'components/Page/Home/ListView'
import Customer from 'components/Page/Home/Customer'
import { getCustomerInfo } from 'http/customer'
import { User, Role, Error } from 'types'
import store from '../redux/store'
import { PINCOLORS } from 'utils/constants'
import { dateString, normaliseID, toTitleCase } from 'utils/common'

interface IProps extends RouteComponentProps {
  error: Error
  user: User
  customer: any
  tanks: any
  geos: any[]
}

interface IState {
  mapViewOn: boolean
}

class Home extends React.PureComponent<IProps, IState> {
  state = {
    mapViewOn: false
  }

  loadCustomerInfo = async (id: string) => {
    try {
      const customer = await getCustomerInfo(id)
      if (customer.messageStatus !== 'error') {
        // TODO store customer info somewhere
      } else {
        console.error(customer.messageCode)
      }
    } catch (error) {
      console.error(error)
    }
  }

  componentDidMount() {
    const { user, customer } = this.props

    if (user.role === Role.CUSTOMER && !customer) {
      // this.loadCustomerInfo(user.customerId)
    }
  }

  toggleMapView = () => {
    this.setState({
      ...this.state,
      mapViewOn: !this.state.mapViewOn,
    })
  }

  viewTankInfo = (tankId: string) => this.props.history.push(`/tank/${tankId}`)

  exportData = (fileName: string) => {
    const { tanks } = this.props;

    const exportedData = [];
    const mBatteryStyles = [];
    const sBatteryStyles = [];

    Object.values(tanks).forEach(({
      deviceID,
      tankId,
      type,
      product,
      sh,
      name,
      suburb,
      zone,
      info,
      sensor,
      status,
      dporhe,
    }, index) => {
      let level;

      if (zone === 'unassigned' || zone === 'wip') {
        level = Math.round(info.value * 100) + '%';
      } else if (info.value > 200) {
        level = 'Invalid';
      } else if (info.value < 0) {
        level = '0%';
      } else {
        level = Math.round(info.value * 100) + '%';
      }

      const mBattery = info.data?.mbat?.toFixed(2);
      const sBattery = info.data?.sbat?.toFixed(2);

      if (mBattery !== undefined && mBattery < 3.1) {
        mBatteryStyles[index + 1] = {
          font: {
            color: {
              rgb: "FF0000",
              bold: true
            }
          }
        }
      }

      if (sBattery && sBattery < 9) {
        sBatteryStyles[index + 1] = {
          font: {
            color: {
              rgb: "FF0000",
              bold: true
            }
          }
        }
      }

      exportedData.push({
        "Device ID": normaliseID(deviceID),
        "Tank ID": normaliseID(tankId),
        "Type": type === 'blereader' ? 'BLE Reader' : toTitleCase(type),
        "Product": product,
        "Account": sh || "-",
        "Name": name,
        "Suburb": suburb,
        "Level": level,
        "Main Battery": mBattery ? mBattery + ' v' : '',
        "Second Battery": sBattery ? sBattery + ' v' : '',
        "Last Updated": info.lastUpdatedDashBoard ? dateString(info.lastUpdatedDashBoard, true) : '',
        "Rssi": sensor?.rssi || "",
        "Dporhe": dporhe,
        "Status": status,
      })
    });

    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtenstion = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(exportedData);
    for (let c in ws) {
      if (typeof(ws[c]) != "object") continue;
      let cell = XLSX.utils.decode_cell(c);
      if (cell.r > 0) {
        let style;
        if (cell.c === 8) {
          // Main Battery Column
          style = mBatteryStyles[cell.r];
        } else if (cell.c === 9) {
          // Second Battery Column
          style = sBatteryStyles[cell.r];
        }
        ws[c].s = style;
      }
    }

    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtenstion);
  }

  render() {
    const { mapViewOn } = this.state
    const { tanks, geos, user, customer, error } = this.props
    let user_role = user.role;
    let isFirstTimeLoad;
    localStorage.setItem('currentDate', Date.now().toString());
    if (localStorage.getItem('user_role') == user_role.toString()) {
      // console.log("do_nothing role already set in local");
    }
    else {
      localStorage.removeItem('user_role');
      localStorage.setItem('user_role', user_role.toString());
    }
    var typeSelected;
    var geoZoneSelected;
    //home page load image will be for fiters only (Admin user)
    if (user_role == Role.ADMIN || user_role == Role.CLT || user_role == Role.CUSTOMER) {
      let filterState = store.getState().filter;
      //Added typeSelected to cehck the type.To display No Of Days for Movable types(e.g Pallet, Pack etc) 
      typeSelected = filterState["type"];
      geoZoneSelected= filterState["geoZone"];
      if (filterState["country"] == '' && filterState["zone"] == '' && filterState["status"] == '' && filterState["product"] == ''
        && filterState["type"] == '' && filterState["sh"] == '' && filterState["tankId"] == '' && filterState["customer"] == '') {
        isFirstTimeLoad = true;
      }
    }
    else {
      isFirstTimeLoad = false;
    }

    // To display color notes for Google map marker colors
    var displayData = [];
    var count = 0;
    PINCOLORS.forEach((value, key) => {
      var colorcode = value;
      count++;
      displayData.push(<div key={value + count} style={{ marginRight: '2px', height: '20px', width: '20px', border: '1px solid black', backgroundColor: colorcode }}></div>);
      displayData.push(<div key={key + count} style={{ marginRight: '10px' }}>{toTitleCase(key)}</div>);
    })
    return (
      <Page>
        <Grid container direction="column">
          <Grid container>
            <Grid item xs={12} sm={8}>
              <Filter userZone={user.zone} countryFilter={user.countryFilter}  stateFilter={user.stateFilter} role={user.role} />
            </Grid>
            <Grid
              container
              item
              justify="flex-end"
              alignItems="center"
              xs={12}
              sm={4}
            >
              <Grid item>
                <Typography variant="h4">View {`${mapViewOn ? 'List' : 'Map'}`}</Typography>
              </Grid>
              <Grid item>
                <Switch onChange={this.toggleMapView} checked={mapViewOn} />
              </Grid>
            </Grid>
          </Grid>
          {customer && (
            <Grid item>
              <Customer {...customer} />
            </Grid>
          )}
          {error !== Error.NONE && (
            <Grid item>
              <Box mt={{ xs: 2 }}>
                <Typography variant="h4" color="error">
                  {error}
                </Typography>
              </Box>
            </Grid>
          )}
          {isFirstTimeLoad ? (
            <Grid item>
              <Box mt={{ xs: 2, md: 4 }}>
                <Typography variant="h3" color="textSecondary">
                  <img style={{ width: '100%', height: '55%' }} src="/images/logos/beacon_image.png" alt="" />
                </Typography>
              </Box>
            </Grid>
          ) : (
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <Grid container justify="flex-end">
                  <Button variant='contained' onClick={() => this.exportData("devices")}>
                    <Typography variant="h4" color="primary">
                      Download
                    </Typography>
                  </Button>
                </Grid>
              </Grid>
              <Grid item>
                <Typography variant="h4" color="error">
                  {Object.values(tanks).length} devices found.
                </Typography>
              </Grid>
              <Grid item>
                {!mapViewOn && (
                  <ListView userRole={user.role} tanks={Object.values(tanks)} viewTankInfo={this.viewTankInfo} typeSelected={typeSelected} />
                )}
                {mapViewOn && (<div style={{ display: 'flex', flexDirection: "row", justifyContent: 'flex-end' }}>{displayData}</div>)}
                {mapViewOn && <MapView geos={geos} viewTankInfo={this.viewTankInfo} geoZoneSelected={geoZoneSelected}/>}
              </Grid>
            </Grid>
          )}
        </Grid>
      </Page>
    )
  }
}

const mapStateToProps = ({ filter: { error, filtered } }) => ({
  error,
  tanks: filtered.tanks,
  geos: filtered.geos,
})

export default connect(mapStateToProps)(withRouter(Home))
